import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { deleteAssetSubType } from '@api/assetTypes';

import { ESnackbarTypes } from '@enums/common';

import { DELETE_ASSET_SUB_TYPE, MANAGE_ASSET_TYPES } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateDeleteAssetSubType = (closeModal: () => void) => {
	const queryClient = useQueryClient();

	const dispatch = useAppDispatch();

	const {
		mutate: handleDeleteAssetSubType,
		isLoading: isLoadingDeleteAssetSubType,
	} = useMutation<string>({
		mutationKey: [DELETE_ASSET_SUB_TYPE],
		mutationFn: deleteAssetSubType,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.assetSubTypeDeleted,
				type: ESnackbarTypes.success,
			}));

			closeModal();

			return [queryClient.invalidateQueries([MANAGE_ASSET_TYPES])];
		},
	});

	return {
		handleDeleteAssetSubType,
		isLoadingDeleteAssetSubType,
	};
};
